import React, { Fragment } from 'react'
import styled from 'styled-components'
import { ReactComponent as RightArrowHeadIcon } from '../assets/right-arrow-head.svg'

const RightArrowHead = styled(RightArrowHeadIcon)`
  fill: ${props => props.theme.colors.grey};
  height: 14px;
`

const DownArrowHead = styled(RightArrowHead)`
  transform: rotate(90deg);
`

export default ({ on }) => (
  <Fragment>
    {on ? <DownArrowHead /> : <RightArrowHead />}
  </Fragment>
)
